
interface OpeningTime {
  day: string;
  hours: string;
  isOpen: boolean;
}

interface OpeningTimesSectionProps {
  openingHours: Array<{
    day_of_week: number;
    open_time: string;
    close_time: string;
    is_closed: boolean;
  }> | undefined;
  hoursLoading: boolean;
}

const OpeningTimesSection = ({ openingHours, hoursLoading }: OpeningTimesSectionProps) => {
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  
  const defaultOpeningHours = dayNames.map((day) => ({
    day,
    hours: 'Hours not set',
    isOpen: false
  }));

  const formattedOpeningHours = openingHours && openingHours.length > 0 
    ? openingHours.map(hour => ({
        day: dayNames[hour.day_of_week],
        hours: hour.is_closed ? 'Closed' : `${hour.open_time} - ${hour.close_time}`,
        isOpen: !hour.is_closed
      }))
    : defaultOpeningHours;

  if (hoursLoading) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-6" data-section="opening-times">
        <h2 className="text-lg sm:text-xl font-semibold mb-4">Opening times</h2>
        <div className="space-y-3">
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <div key={i} className="animate-pulse flex justify-between">
              <div className="h-4 bg-gray-300 rounded w-20"></div>
              <div className="h-4 bg-gray-300 rounded w-32"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-6" data-section="opening-times">
      <h2 className="text-lg sm:text-xl font-semibold mb-4">Opening times</h2>
      <div className="space-y-3">
        {formattedOpeningHours.map((time) => (
          <div key={time.day} className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className={`w-2 h-2 rounded-full ${time.isOpen ? 'bg-green-500' : 'bg-gray-300'}`}></div>
              <span className="text-gray-900 font-medium text-sm sm:text-base">{time.day}</span>
            </div>
            <span className="text-gray-600 text-sm sm:text-base">{time.hours}</span>
          </div>
        ))}
        {(!openingHours || openingHours.length === 0) && (
          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-blue-700 text-sm">
              Opening hours haven't been set yet. Contact the provider directly for availability.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OpeningTimesSection;
